var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProwessIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1311 -1407)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 10,
    transform: "translate(1311 1407)",
    fill: "#ffbe8d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(1367 1439)",
    fill: "#621bc0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1311.619 1410.7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.381 7.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.385,46a4.287,4.287,0,0,0-2.67,7.639V60.1a2.67,2.67,0,1,0,5.341,0V53.639a4.47,4.47,0,0,0,1.615-3.354A4.294,4.294,0,0,0,47.385,46Z",
    transform: "translate(-25.265 -21.966)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1,20.1a6.427,6.427,0,0,0-6.4,6.4v5.03a14.889,14.889,0,0,1,6.4-1.49,13.859,13.859,0,0,1,6.4,1.49V26.5A6.388,6.388,0,0,0,46.1,20.1Z",
    transform: "translate(-23.976 -12.151)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.61,35.371V15.808a2.389,2.389,0,0,0-.869-1.8,2.448,2.448,0,0,0-1.677-.621h-.248a23.027,23.027,0,0,1-2.919.186A22.744,22.744,0,0,1,38.178,7.983a2.4,2.4,0,0,0-3.354,0,22.158,22.158,0,0,1-14.718,5.589,23.027,23.027,0,0,1-2.919-.186h-.248a2.448,2.448,0,0,0-1.677.621,2.3,2.3,0,0,0-.869,1.8V35.371c-.062,1.118-.124,8.2,6.583,15.339,3.167,3.354,7.825,6.707,14.656,9.5a2.422,2.422,0,0,0,1.863,0c8.073-3.291,13.042-7.39,16.147-11.3C58.8,42.388,58.672,36.364,58.61,35.371ZM36.5,54.188a14.514,14.514,0,0,1-9.253-25.711V21.646a9.253,9.253,0,1,1,18.507,0v6.831A14.514,14.514,0,0,1,36.5,54.188Z",
    transform: "translate(-14.381 -7.3)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProwessIcon6);
export default __webpack_public_path__ + "static/media/prowess-icon6.984b39c011a73556dd3734ae9c8cd3e9.svg";
export { ForwardRef as ReactComponent };